<!--浏览器兼容页面-->
<template>
	<div class='compatible-content' :style="{minHeight:height+'px',}">
		<div class="content">
			<img class="logo" src="../assets/img/login/icon-compatible-log.png" alt="">
			<div>
				<img src="../assets/img/login/icon-compatible.png" alt="">
				<p>你的浏览器版本太低了，已经和时代脱轨了~</p>
				<p>为了提高您的用户体验，推荐下载</p>
			</div>
		</div>
		<div class="footer">
			<div><img src="../assets/img/icon-gg.png" alt=""><a target="_blank" href="https://www.google.cn/intl/zh-CN/chrome/">谷歌浏览器</a></div>
			<div><img src="../assets/img/icon-hh.png" alt=""><a target="_blank" href="http://www.firefox.com.cn/">火狐浏览器</a></div>
		</div>
	</div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {
        height:''
      }
    },
    created() {
      this.height = document.documentElement.clientHeight
    },
    methods: {}
  }
</script>

<style scoped lang='less'>
	.compatible-content{
		width: 100%;
		height: 100%;
		background-image: url("../assets/img/index/compatible.png");
		background-size: 100% 100%;
		position: relative;
		.content{
			display: flex;
			align-items: center;
			position: absolute;
			top: 68%;
			left: 50%;
			transform: translate(-50%,-50%);
			img{
				width: auto;
				height: auto;
				max-width: 100%;
				max-height: 100%;
			}
			div{
				margin-left: 37px;
				p{
					color: #ffffff;
					font-size: 20px;
					margin-top: 20px;
				}
			}
		}
		.footer{
			display: flex;
			align-items: center;
			position: absolute;
			top:85%;
			left: 50%;
			transform: translate(-50%,-50%);
			div:first-child{
				margin-right: 161px;
			}
			img{
				display: inline-block;
				vertical-align: middle;
			}
			a{
				color: #ffffff;
				font-size: 24px;
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/compatible.vue